import { Directive, ElementRef, Input, HostListener } from "@angular/core";

@Directive({
  selector: "[menuClose]",
})
export class MenuCloseDirective {
  @Input()
  public menu: any;

  constructor(private element: ElementRef) {}

  @HostListener("click")
  private onClick() {
    console.log(this.menu);
    this.menu.classList.remove("show");
  }
}
